<template>
  <div class="list-grid" :id="uuid">
    <template v-for="(location, i) in locations">
      <div class="list-grid-header" :key="i">
        <div class="list-grid-header-map">
          <button type="button" class="map-show btn btn-small btn-dark" @click="showMap">
            <IconMap />
            View Map
          </button>
        </div>
        <button type="button" class="list-grid-header-mag" @click="setZoomToLocation(location)">
          <IconZoom />
        </button>
        <h2 class="list-grid-header-title">{{ location.name }}</h2>
        <div class="list-grid-header-num">{{ communitiesByLocation(location.slug).length }} neighborhoods</div>
      </div>

      <div class="list-grid-box" @click="showDetail(community, $event)" v-for="community in communitiesByLocation(location.slug)" :key="`${community.id}-${community.slug}`">
        <div class="list-grid-box-image slick-loading">
          <div class="list-slider" :id="`list-slider-${community.id}`">
            <div class="list-slider-slide" v-for="(slide, i) in community.slide_images" :key="`list-slider-slide-${i}`">
              <img :src="slide.url" :alt="slide.title" />
            </div>
          </div>
          <div class="list-grid-box-image-badge align-right">{{ community.availability }}</div>
          <div class="list-detail-slider-controls">
            <button type="button" class="arrow-prev" :id="`arrow-prev-${community.id}`">
              <IconTriangleLeft />
            </button>
            <button type="button" class="arrow-next" :id="`arrow-next-${community.id}`">
              <IconTriangleRight />
            </button>
          </div>
        </div>
        <div class="list-grid-box-title">{{ community.title }}</div>
        <div class="list-grid-box-cost">{{ startingAt(community.price) }}</div>
        <div class="list-grid-box-location">Location: {{ community.location }}</div>
        <div class="list-grid-box-school">School District: {{ community.school_district }}</div>
      </div>
    </template>
  </div>
</template>
<script>
import IconMap from '@/components/icons/IconMap';
import IconTriangleLeft from '@/components/icons/IconTriangleLeft';
import IconTriangleRight from '@/components/icons/IconTriangleRight';
import IconZoom from '@/components/icons/IconZoom';
import hasSlickSlider from '@/mixins/hasSlickSlider';
import { uuidv4 } from '@/helpers/ui';

export default {
  name: 'CommunityListGrid',
  components: { IconMap, IconTriangleLeft, IconTriangleRight, IconZoom },
  mixins: [hasSlickSlider],
  data() {
    return {
      sliderClass: '.list-slider',
    };
  },
  watch: {
    communities: {
      handler: function(newCommunities, oldCommunities) {
        if (newCommunities.length !== oldCommunities.length) {
          this.sliderUpdatePending = true;
        }
      },
    },
    isMapDisplayed: {
      handler: function() {
        this.resizeSlickSlider(this.uuid);
      },
    },
  },
  computed: {
    communities() {
      return this.$store.getters['communities/getCommunities'];
    },
    isMapDisplayed() {
      return this.$store.getters['ui/isMapDisplayed'];
    },
    locations() {
      return this.$store.getters['communities/getCommunityLocations'];
    },
    uuid() {
      return uuidv4();
    },
  },
  methods: {
    communitiesByLocation(location) {
      return this.$store.getters['communities/getCommunitiesByLocation'](location);
    },
    setZoomToLocation(location) {
      this.$store.dispatch('ui/setZoomToLocation', { location });
    },
    showDetail(community, event) {
      if (this.isMapDisplayed) {
        this.$store.dispatch('ui/setPanelView', { community, panelView: 'detail' });
      } else {
        if (event.target.className !== 'slick-slider-button') {
          window.location = community.link;
        }
      }
    },
    showMap() {
      this.$store.dispatch('ui/setMapDisplay', { mapDisplay: true });
    },
    startingAt(price) {
      const thePrice = Number(price.replaceAll(',', ''));
      if (thePrice > 0) {
        const formattedAmount = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0  // Ensures at most two decimal places
        }).format(thePrice);

        return formattedAmount;
      } else {
        return 'Contact Us';
      }
    },
  },
};
</script>
